export interface OrderExt {
	completePaymentUrl: string;
	errorPaymentUrl?: string;
	category?: string;
	paymentMethodCode?: string;
	cardId?: string; // required checkout 快捷支付
	token?: string; // required checkout tokenized
	name?: string; // required checkout tokenized
	email?: string; // required checkout tokenized
	nationalId?: string; // 巴西 CPF code
	fullName?: string; // required  巴西
}

export interface OrderParams {
	currency: string;
	price: number;
	channelId?: number;
	channelCode?: string;
	companyCode: string;
	ext: OrderExt;
}

export interface OrderResponse {
	txnId: string;
	orderId: string;
	ext: {
		redirectUrl: string;
		bankName?: string;
		bankCode?: string;
		beneficiaryName?: string;
		bankAccount?: string;
		referenceNumber?: string;
		bankAccountType?: string;
	};
	status: string;
}

export interface WriteTransferSupportResponse {
	currency: string;
	supportWireTransfer: boolean;
}

export interface CardItem {
	title: string;
	description: string;
	icon: string;
	serveKey: string;
	companyCode: string;
	feeRate: string;
	category: string;
	needToFx: boolean;
	support: boolean;
}

export enum PaymentMethodsServerKeys {
	CARD = "card",
	E_WALLET = "ewallet",
	BANK = "OnlineBanking",
	WIRE_TRANSFER = "WireTransfer",
	SG_WIRE_TRANSFER = "SGWireTransfer",
	HK_WIRE_TRANSFER = "HKWireTransfer",
}
export enum CompanyCodes {
	CHECKOUT = "checkout",
	DUKPAY = "dukpay",
	DCS = "dcs",
}

export const PaymentMethodsFromServer = [
	{
		title: "card-title",
		description: "card-description",
		icon: "credit",
		serveKey: PaymentMethodsServerKeys.CARD,
		companyCode: "",
		feeRate: "",
		category: "",
		needToFx: false,
		support: false,
	},
	{
		title: "eWallet-title",
		description: "eWallet-description",
		icon: "ewallet",
		serveKey: PaymentMethodsServerKeys.E_WALLET,
		companyCode: "",
		feeRate: "",
		category: "",
		needToFx: false,
		support: false,
	},
	{
		title: "online-banking-title",
		description: "online-banking-description",
		icon: "online-banking",
		serveKey: PaymentMethodsServerKeys.BANK,
		companyCode: "",
		feeRate: "",
		category: "",
		needToFx: false,
		support: false,
	},
];

export const GlobalRegion = "Global";

export const WireTransfer = {
	title: "wire-transfer-title",
	description: "wire-transfer-description",
	icon: "wire-tranfer",
	serveKey: PaymentMethodsServerKeys.WIRE_TRANSFER,
	companyCode: "",
	feeRate: "",
	category: "",
	needToFx: false,
	support: false,
};

export interface CountryModel {
	label: string;
	value: string;
	currency: string;
}

export enum CardSchemes {
	VISA = "VISA",
	MASTER = "MASTERCARD",
}

export enum CardStatuses {
	unverified = 0, // 待验证
	verified = 1, // 已验证
	verifying = 2, // 验证中
	verifiedError = 3, // 验证失败
}

export interface QuickCardModel {
	cardId: string;
	cardMask: string; // 卡号后四位
	bin: string; // 卡号前四位
	scheme: CardSchemes;
	cardType: "Credit" | "Debit";
	expireMonth: string;
	expireYear: string;
	cardStatus: number;
	name: string;
}

export interface Country {
	name: string;
	phoneCode: string;
	currency: string;
	currencyName: string;
	currencySymbol: string;
	emoji: string;
	acronym: string;
}

export interface PaymentModel {
	category: string;
	feeRate: string;
	companyCode: string;
}

export const RapydSupportContries = [
	{
		value: "MY",
		currency: "MYR",
	},
	{
		value: "PH",
		currency: "PHP",
	},
	{
		value: "TH",
		currency: "THB",
	},
	{
		value: "VN",
		currency: "VND",
	},
	{
		value: "ID",
		currency: "IDR",
	},
];

export interface PaymentModelFromServer {
	category: string; // 下单参数
	categoryKey: string; // 映射UI用
	companyCode: string;
	feeRate: string;
	needToFx: boolean; // 兑换提醒Modal
}

export interface ResponsePayment {
	channels: PaymentModelFromServer[];
	region: string;
}

export interface ResponseMasterAccountInfo {
	masterAccountNameLocal: string;
	region: string;
	email: string;
}

export interface ResponsePaymentErrorInfos {
	companyCode: string;
	errorCode: string;
	code: number;
	orderStatus: number;
}

export interface ResponseNextChannel {
	category: string;
	feeRate: string;
	companyCode: string;
	categoryKey: string;
}

export interface ResponseChannel {
	id: string;
	paymentMethodCode: string;
	feeRate: string;
	companyCode: string;
	channelCode: string;
	channelName: string;
	channelLogo: string;
	defaultRegion: string; // 用户显示
	multistage: boolean; // 是否有下级渠道
	support: boolean; // 是否支持【false UI展示半透明】
	autoExchange: boolean; // 换汇Modal提示
}

export const DukpayCards: { [key: string]: { title: string; icon: string } } = {
	OVO: {
		title: "OVO",
		icon: "ovo.webp",
	},
	LINKAJA: {
		title: "LinkAja",
		icon: "link-aja.webp",
	},
	SHOPEEPAY: {
		title: "ShopeePay",
		icon: "shopeepay.webp",
	},
	GCASH: {
		title: "GCash",
		icon: "g-cash.webp",
	},
	PAYMAYA: {
		title: "PayMaya",
		icon: "paymaya.webp",
	},
	GRABPAY: {
		title: "GrabPay",
		icon: "grabapy.webp",
	},
};

export interface Currency {
	currency: string;
	defaultRegion: string;
	switchCountry: boolean;
	threshold: string;
	leverageThreshold: string;
	multiLanguageName: string;
}

//  开户国家 [选择币种默认展示币种]
export const openAccountCountriesConfigs = [
	{ region: "SG", currency: "SGD" },
	{ region: "BR", currency: "BRL" },
	{ region: "MX", currency: "MXN" },
	{ region: "PH", currency: "PHP" },
	{ region: "ID", currency: "IDR" },
	{ value: "TH", currency: "THB" },
	{ value: "MY", currency: "MYR" },
];

// 自动换汇提醒货币
export const autoExchangeCurrencies = ["IDR", "PHP", "THB", "MYR", "VND"];

export interface BackAccountResponse {
	depositBankAccountId: string;
	acNo: string;
	bankName: string;
	bankCode: string;
	acName: string;
	swiftCode: string;
	bankAddress: string;
	postScriptMessage: string;
	beneficiaryAddress: string;
	fpsCode: string;
	type?: 1 | 2; // 1: 美元电汇 2: 美元香港本地转账
}

export interface WireTransferOrderParams {
	depositBankAccountId: string;
	currency: string;
	amount: string;
	receiptImages: string[];
	autoExchange?: boolean; // 是否自动换回
}

export enum DepositType {
	WIRE_TRANSFER = "WIRE_TRANSFER",
	SG_WIRE_TRANSFER = "SG_WIRE_TRANSFER",
	HK_WIRE_TRANSFER = "HK_WIRE_TRANSFER",
	THIRD_DEPOSIT = "THIRD_DEPOSIT",
}

/**
 * USD 入金选项
 */
export const USDDepositOption: Record<string, number> = {
	level50: 50,
	level100: 100,
	level200: 200,
	level500: 500,
	level1000: 1000,
	level2500: 2500,
	level3500: 3500,
	level5000: 5000,
	level10000: 10000,
	level11000: 11000,
	level30000: 30000,
	level50000: 50000,
	level110000: 110000, // 用户判断五星头像
};

export interface RateModel {
	base: string; // root currency
	quote: string; // remote currency
	rate: number;
}
export type CurrencyOptionMap = Map<string, Record<string, number>>;

/**
 *
 * 入金金额奖励
 * amount 美元金额
 * 其他 币种通过汇率 转为美元
 *
 */
export const getDepositBonus = (amount: string) => {
	const numPrice = Number(amount);

	if (numPrice < USDDepositOption.level200) {
		return 0;
	}

	if (numPrice >= USDDepositOption.level200 && numPrice < USDDepositOption.level1000) {
		return 6;
	} else if (numPrice >= USDDepositOption.level1000 && numPrice < USDDepositOption.level2500) {
		return 20;
	} else if (numPrice >= USDDepositOption.level2500) {
		return 40;
	} else {
		return 0;
	}
};

/**
 * 入金选项规则&最小入金规则
 * 数据来源：https://rockflow.feishu.cn/sheets/shtcn9HdDzUbK9z8uzBbnR7WeGc?sheet=LudoMo
 */
const depositOptionsRules = {
	//  en + (菲律宾)  !(zh-Hans、zh-Hant、ko)
	limit200Rule: {
		limit: "level50",
		initial: "level1000",
		options: ["level200", "level1000", "level2500", "level3500", "level5000", "level11000"],
	},
	// zh-Hans、zh-Hant、ko、en +（！菲律宾）
	limit1000Rule: {
		limit: "level500",
		initial: "level3500",
		options: ["level500", "level3500", "level10000", "level30000", "level50000", "level110000"],
	},
};

/**
 * en + 其他情况  500
 * en + 菲律宾人  100
 * zh-Hans       500
 * zh-Hant       500
 * ko            500
 * 其他语言       100
 */
export function getDepositOptions(locale: string, region: string) {
	const _locale = locale.toLocaleLowerCase();
	const PH = "PH";
	const support500Locales = ["zh-hans", "zh-hant", "ko"];

	if (_locale === "en") {
		return region === PH ? depositOptionsRules.limit200Rule : depositOptionsRules.limit1000Rule;
	}

	return support500Locales.includes(_locale) ? depositOptionsRules.limit1000Rule : depositOptionsRules.limit200Rule;
}
